"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var primaryHeader_1 = require("./primaryHeader");
var searchBarHandler_1 = __importDefault(require("./searchBarHandler"));
var menuState_1 = __importDefault(require("./menuState"));
exports.default = (function () {
    var header = document.querySelector('.Header');
    var headerMobileNav = document.querySelector('.Header__mobileNav');
    var headerMobileNavItems = Array.from(document.querySelectorAll('.HeaderMobileNav__item > a'));
    var mobileSubMenuContainer = document.querySelector('.HeaderMobileSubNav__container');
    var mobileIcon = document.querySelector('.Header__mobileIcon');
    var closeSubMenuButtons = Array.from(document.querySelectorAll('[data-close-submenu]'));
    if (!header || !headerMobileNav || !mobileIcon || !mobileSubMenuContainer) {
        return;
    }
    var openMobileNav = function () {
        headerMobileNav.classList.add('is-open');
        header.classList.add('mobileNavIsOpen');
        document.body.style.overflow = 'hidden';
        menuState_1.default.mobileMenuOpen = true;
        if (primaryHeader_1.FixedHeaderApi) {
            primaryHeader_1.FixedHeaderApi.freeze();
        }
    };
    var closeMobileNav = function () {
        closeSubMenu();
        headerMobileNav.classList.remove('is-open');
        document.body.style.overflow = '';
        menuState_1.default.mobileMenuOpen = false;
        if (primaryHeader_1.FixedHeaderApi) {
            primaryHeader_1.FixedHeaderApi.unfreeze();
        }
        // Cleanup actions that need to be run after the animation is complete.
        setTimeout(function () {
            header.classList.remove('mobileNavIsOpen');
        }, 250);
    };
    var closeSubMenu = function () {
        header.classList.remove('Header--mobileSubMenuVisible');
        mobileSubMenuContainer.classList.add('is-hidden');
        searchBarHandler_1.default('fadeIn');
        if (menuState_1.default.activeMenuItem.linkNode && menuState_1.default.activeMenuItem.subMenuNode) {
            menuState_1.default.activeMenuItem.linkNode.setAttribute('aria-expanded', 'false');
            menuState_1.default.activeMenuItem.subMenuNode.classList.add('is-hidden');
        }
    };
    var openSubMenu = function (e, item) {
        var subMenu = item.dataset.jsAction;
        var subMenuGroup = document.querySelector(".HeaderMobileSubNav__group[data-js-target=\"" + subMenu + "\"]");
        if (!subMenu || !subMenuGroup) {
            return;
        }
        e.preventDefault();
        searchBarHandler_1.default('fadeOut');
        header.classList.add('Header--mobileSubMenuVisible');
        mobileSubMenuContainer.classList.remove('is-hidden');
        item.setAttribute('aria-expanded', 'true');
        subMenuGroup.classList.remove('is-hidden');
        menuState_1.default.open = true;
        menuState_1.default.activeMenuItem.linkNode = item;
        menuState_1.default.activeMenuItem.subMenuNode = subMenuGroup;
    };
    mobileIcon.addEventListener('click', openMobileNav);
    headerMobileNav.addEventListener('click', function (e) { return (e.target === headerMobileNav ? closeMobileNav() : false); });
    // Events for menu items
    headerMobileNavItems.forEach(function (item) {
        item.addEventListener('click', function (e) { return openSubMenu(e, item); });
    });
    closeSubMenuButtons.forEach(function (item) { return item.addEventListener('click', closeSubMenu); });
});
